import type * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'

import type { Feature } from './feature'

/** Reads cached results for any zone. */
export class Selectors {
  /** The request entry for a specified zone. */
  public readonly getEntry
  /** The zone's apps, or an empty list before success or after an error. */
  public readonly getApps
  /** Whether a zone needs an app request, including a retry after an error. */
  public readonly getShouldRequest
  /** The apps or error once a zone's request has settled. */
  public readonly getResult

  constructor(feature: Feature) {
    const lookup = feature.state.project(state => state.lookup)
    this.getEntry = feature.createSelectorMethod(
      (zoneId: ents.core.admin.Zone.Id) =>
        lookup.project(byZone => byZone[zoneId]).asSelector,
    )
    this.getApps = feature.createSelectorMethod(
      (zoneId: ents.core.admin.Zone.Id) =>
        this.getEntry(zoneId).project(entry => entry?.data ?? []).asSelector,
    )
    this.getShouldRequest = feature.createSelectorMethod(
      (zoneId: ents.core.admin.Zone.Id) =>
        this.getEntry(zoneId).project(
          entry => entry?.data === undefined && entry?.isLoading !== true,
        ).asSelector,
    )
    this.getResult = feature.createSelectorMethod(
      (zoneId: ents.core.admin.Zone.Id) =>
        this.getEntry(zoneId).project(entry => ({
          apps: entry?.data,
          error: entry?.error,
          isSettled: entry?.data !== undefined || entry?.error !== undefined,
        })).asSelector,
    )
  }
}
